import React from "react";
import {
  Wrapper,
  Copy,
  Bold,
  Title,
  Button
} from "app/NativeComponents/common";

import { toTitleCase, numberFormat, openUrl } from "app/NativeActions";

import moment from "moment";

const handleUrlPress = url => {
  openUrl(url);
};

const InformationItem = ({ style, label, item, format, size }) => {
  let formatted_item = "";
  if (item != "" && item != null) {
    switch (format) {
      default:
        formatted_item = item;
        if (formatted_item == 0 || formatted_item == "0") {
          formatted_item = "--";
        }
        break;

      case "url":
        formatted_item = item;
        if (!formatted_item) {
          formatted_item = "--";
        }
        break;

      case "name":
      case "text":
        formatted_item = toTitleCase(item);

        break;

      case "company_name":
        formatted_item = toTitleCase(item);
        break;

      case "money":
      case "price":
        if (parseInt(item) == 0) {
          formatted_item = "--";
        } else {
          formatted_item = "$" + numberFormat(parseInt(item));
        }

        break;

      case "date":
        formatted_item = moment(item).format("MMM Do, YYYY");
        break;
      case "percent":
        formatted_item = parseInt(parseFloat(item) * 100) + "%";
        break;
      case "term":
        if (parseInt(item) > 60) {
          formatted_item = item + " Month";
        } else {
          formatted_item = item + " Year";
        }
        break;
      case "number":
        formatted_item = numberFormat(parseInt(item));

        break;
      case "acre":
        formatted_item = parseFloat(item).toFixed(2);
        break;

      case "feet":
        formatted_item = numberFormat(parseInt(item)) + " ft";
        break;
    }
  } else {
    formatted_item = "--";
  }

  if (size == "small") {
    return (
      <Wrapper style={style}>
        <Copy style={{ fontSize: 11 }}>
          <Bold>{label}</Bold>
        </Copy>
        <Copy style={{ fontSize: 11 }}>{formatted_item}</Copy>
      </Wrapper>
    );
  }

  if (size == "medium") {
    if (format == "url" && formatted_item != "--") {
      return (
        <Button onPress={() => openUrl(item)} style={style}>
          <Copy style={{ fontSize: 14 }}>
            <Bold>{label}</Bold>
          </Copy>
          <Copy style={{ fontSize: 14 }}>{formatted_item}</Copy>
        </Button>
      );
    }

    return (
      <Wrapper style={style}>
        <Copy style={{ fontSize: 14 }}>
          <Bold>{label}</Bold>
        </Copy>
        <Copy style={{ fontSize: 14 }}>{formatted_item}</Copy>
      </Wrapper>
    );
  }

  return (
    <Wrapper style={style}>
      <Copy>{label}</Copy>
      <Title>{formatted_item}</Title>
    </Wrapper>
  );
};

export { InformationItem };
